import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
if (!backendUrl) throw new Error("REACT_APP_BACKEND_URL non configurato");

export const apiBase = `${backendUrl}/api/v1`;
export const api = axios.create({ baseURL: apiBase, withCredentials: true });

export function errorMessage(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  return "Operazione non riuscita. Riprova.";
}